import createReducer from './createReducer';
import {
  FETCH_USER_DETAILS,
  FETCH_USER_DETAILS_SUCCESS,
  FETCH_USER_DETAILS_FAILURE,
  FETCH_USER_ENTITLEMENTS,
  FETCH_USER_ENTITLEMENTS_SUCCESS,
  FETCH_USER_ENTITLEMENTS_FAILURE,
  FETCH_USER_FAVORITES,
  FETCH_USER_FAVORITES_SUCCESS,
  FETCH_USER_FAVORITES_FAILURE,
  FETCH_USER_SETTINGS,
  FETCH_USER_SETTINGS_SUCCESS,
  FETCH_USER_SETTINGS_FAILURE,
  FETCH_PAYMENT_WARNINGS,
  FETCH_PAYMENT_WARNINGS_SUCCESS,
  FETCH_PAYMENT_WARNINGS_FAILURE,
  SET_USER_LOCATION,
  SET_USER_LOCATION_SUCCESS,
  SET_USER_LOCATION_FAILURE,
  SET_DFP_AD_ATTRIBUTES,
  SET_DFP_AD_ATTRIBUTES_SUCCESS,
  SET_DFP_AD_ATTRIBUTES_FAILURE,
  SET_USER_BW_WIND_WAVE_MODEL,
  SET_USER_BW_WIND_WAVE_MODEL_SUCCESS,
  SET_USER_BW_WIND_WAVE_MODEL_FAILURE,
 } from '../actions/user';

const initialState = {
  details: null,
  entitlements: [],
  favorites: [],
  legacyEntitlements: [],
  settings: {
    bwWindWaveModel: 'LOLA',
  },
};

const handlers = {};

handlers[FETCH_USER_DETAILS] = state => ({
  ...state,
  loading: true,
});

handlers[FETCH_USER_DETAILS_SUCCESS] = (state, { details }) => ({
  ...state,
  loading: false,
  details: {
    firstName: details.firstName,
    lastName: details.lastName,
    email: details.email,
    _id: details._id,
    legacyId: details.usID,
  },
});

handlers[FETCH_USER_DETAILS_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[FETCH_USER_ENTITLEMENTS] = state => ({
  ...state,
  loading: true,
});

handlers[FETCH_USER_ENTITLEMENTS_SUCCESS] = (state, { entitlements, legacyEntitlements }) => ({
  ...state,
  loading: false,
  entitlements,
  legacyEntitlements,
});

handlers[FETCH_USER_ENTITLEMENTS_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[FETCH_USER_FAVORITES] = state => ({
  ...state,
  loading: true,
});

handlers[FETCH_USER_FAVORITES_SUCCESS] = (state, { favorites }) => ({
  ...state,
  loading: false,
  favorites,
});

handlers[FETCH_USER_FAVORITES_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[FETCH_USER_SETTINGS] = state => ({
  ...state,
  loading: true,
});

handlers[FETCH_USER_SETTINGS_SUCCESS] = (state, { settings }) => ({
  ...state,
  loading: false,
  settings,
});

handlers[FETCH_USER_SETTINGS_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[FETCH_PAYMENT_WARNINGS] = state => ({
  ...state,
  loading: true,
});

handlers[FETCH_PAYMENT_WARNINGS_SUCCESS] = (state, { warningType }) => ({
  ...state,
  loading: false,
  warningType,
});

handlers[FETCH_PAYMENT_WARNINGS_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[SET_USER_LOCATION] = state => ({
  ...state,
  loading: true,
});

handlers[SET_USER_LOCATION_SUCCESS] = (state, { location }) => ({
  ...state,
  loading: false,
  location,
});

handlers[SET_USER_LOCATION_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[SET_DFP_AD_ATTRIBUTES] = state => ({
  ...state,
  loading: true,
});

handlers[SET_DFP_AD_ATTRIBUTES_SUCCESS] = (state, { adAttributes }) => ({
  ...state,
  loading: false,
  adAttributes,
});

handlers[SET_DFP_AD_ATTRIBUTES_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

handlers[SET_USER_BW_WIND_WAVE_MODEL] = state => ({
  ...state,
  loading: true,
});

handlers[SET_USER_BW_WIND_WAVE_MODEL_SUCCESS] = (state, { bwWindWaveModel }) => ({
  ...state,
  loading: false,
  settings: {
    ...state.settings,
    bwWindWaveModel,
  },
});

handlers[SET_USER_BW_WIND_WAVE_MODEL_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/user.js